@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  @for (option of plainOptions(); track option.value) {
    <!--#region Label Left -->

    @if (settings().labelPosition === 'left') {
      <ng-container
        *ngTemplateOutlet="uiLabelTemplateRef; context: { $implicit: option }"
      ></ng-container>
    }
    <ng-content select="label[slot-left]"></ng-content>

    <!--#endregion Label Left -->

    <div [attr.uidisabled]="option.disabled" uiinputcontent>
      <input
        uivalue
        type="radio"
        [id]="option.value"
        [value]="option.value"
        [disabled]="option.disabled"
        [checked]="value() === option.value"
      />
      <icon
        [class.checked]="value() === option.value"
        (click)="updateRadioValue(option.value)"
        [iconDefinition]="
          value() === option.value ? ICONS.RADIO_CHECKED : ICONS.RADIO_UNCHECKED
        "
      ></icon>
    </div>

    <!--#region Label Right -->

    @if (settings().labelPosition === 'right') {
      <ng-container
        *ngTemplateOutlet="uiLabelTemplateRef; context: { $implicit: option }"
      ></ng-container>
    }
    <ng-content select="label[slot-right]"></ng-content>

    <!--#endregion Label Right -->
  }

  <!--#region Tools -->

  <div uitoolstrip>
    <ng-content #uiToolsMarkupRef select="[uitool]"></ng-content>
    <ng-template #uiToolsCodeRef></ng-template>
  </div>

  <!--#endregion Tools -->

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef let-option>
    <label
      [attr.uidisabled]="option?.disabled"
      [label]="$safeNavigationMigration(option?.label)"
      [labelTip]="labelTip()"
      [state]="state()"
      (click)="
        permDir.uipermission() === PERMISSIONS.VIEW || settings().disabled
          ? false
          : updateRadioValue($safeNavigationMigration(option?.value))
      "
    >
    </label>
  </ng-template>
  <!--#endregion Templates-->
}
